import { PLATFORM_LABELS } from '../../../../../../../constants/selectLists/platformList'

export const findPlatformName = platform => {
  if (PLATFORM_LABELS[platform]) {
    return PLATFORM_LABELS[platform]
  }

  return platform
}
